import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "React is an open-source JavaScript library, backed by Meta, for building modern user interfaces. Its component model and virtual DOM make interfaces fast to render and easy to compose.",
    "We use React to build snappy, maintainable front ends — from marketing sites to complex web apps — that integrate cleanly with whatever powers them behind the scenes.",
];

const FEATURES = [
    { title: "Rapid development", text: "Reusable components let us build and iterate on interfaces quickly." },
    { title: "Super-performant apps", text: "The virtual DOM updates only what changed, keeping the UI smooth and responsive." },
    { title: "Flexible with any stack", text: "React drops into existing systems and pairs with any back end or API." },
    { title: "Quick rendering", text: "Efficient reconciliation means fast first paints and fluid interactions." },
];

const CHECKS = [
    "Single-page applications",
    "Interactive dashboards",
    "Progressive web apps",
    "Reusable component libraries",
    "Front-end for existing APIs",
];

export default function ReactJsDevelopment() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Web Development" title="React JS Development" eyebrowAs="span">
                    Modern, component-driven interfaces built with React — fast, flexible front ends that feel like real products.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
